import {
   SAVE_STACKUP_FULFILLED,
   INIT_STACKUP,
   ADD_LAYER,
   UPDATE_LAYER,
   DELETE_LAYERS,
   RESTORE_STACKUP,
} from '../../actions/action-types';
import { CORE, PREPREG, COPPER } from '../../constants/globals';
import {
  addLayer,
  updateLayer,
  deleteLayers,
  restoreLayerInstance,
  restoreLayerInstances,
  calculateMirrorIndex,
} from '../../lib/stackup';
import { Core, Prepreg } from '../../models';

const initialState = [];

function layers(state = initialState, action){
  switch(action.type){
    case SAVE_STACKUP_FULFILLED:
      return action.payload.layers;
    case INIT_STACKUP:
      return action.payload.layers;
    case RESTORE_STACKUP:
      return action.payload.layers;
    case ADD_LAYER:
      return addLayer(state, action.payload);
    case UPDATE_LAYER:
      return updateLayer(state, action.index, action.payload);
    case DELETE_LAYERS:
      return deleteLayers(state, action.payload)
    default:
      return state;
  }
}

export function getLayers(state) {
  const layers = state;
  return restoreLayerInstances(layers);
}

export function getLayer(state, key) {
  const layers = restoreLayerInstances(state);
  const layer = layers.find(layer => layer.key === key);
  if (layer !== undefined) {
    return layer;
  }
  return undefined;
}

export function getMirrorLayer(state, index) {
  if (state === undefined) {
    return undefined;
  }
  const length = state.length;
  const mirrorIndex =  calculateMirrorIndex(length, index);

  if (mirrorIndex > -1 && mirrorIndex < length) {
    return restoreLayerInstance(state[mirrorIndex]);
  }
  return undefined;
}

export function getCoreCount(state) {
  return state.reduce((acc, layer) => {
    return layer.type === CORE ? acc + 1 : acc;
  }, 0);
}

export function getCopperCount(state) {
  return state.reduce((acc, layer) => {
    return layer.type === COPPER ? acc + 1 : acc;
  }, 0);
}

export function getNeighborPrepreg(state, index, above) {
  const len = state.length;
  const increment = above ? -2 : 2;

  index += increment;
  while(index > 0 && index < len) {
    if (state[index].type === PREPREG) {
      return restoreLayerInstance(state[index]);
    }
    index += increment;
  }
  return undefined;
}

export function getMirrorNeighborPrepreg(state, index, above) {
  const length = state.length;
  const mirrorIndex = calculateMirrorIndex(length, index);

  return getNeighborPrepreg(state, mirrorIndex, !above);
}

export function getCoreMaterialsInUse(state) {
  return state
    .filter(layer => layer.type === CORE)
    .map(layer => Core.restore(layer))
    .map(core => core.material)
    .filter((material, pos, arr) => (
      arr.findIndex(item => item.id === material.id) === pos
    ))
    .sort((a, b) => a.thickness - b.thickness);
}

export function getPrepregMaterialsInUse(state) {
  return state
    .filter(layer => layer.type === PREPREG)
    .map(layer => Prepreg.restore(layer))
    .map(prepreg => prepreg.material)
    .flat()
    .map(wrapper => wrapper.material)
    .filter((material, pos, arr) => (
      arr.findIndex(item => item.id === material.id) === pos
    ))
    .sort((a, b) => a.thickness - b.thickness);
}

export function getCoppersInUse(state) {
  return state
    .filter(layer => layer.type === COPPER)
}

export default layers;



// WEBPACK FOOTER //
// ./src/reducers/stackup/layers.js